module.exports = __webpack_public_path__ + "static/media/QuadFooter.4aedbf11.svg";